import { GuideIdentityPublicPage } from './pages/GuideIdentityPublicPage';

export const guideIdentityPublicRoutes = [
  { path: 'g/:identityCode', element: <GuideIdentityPublicPage /> },
];
